import Sprite from '../../Sprite';
import Point from '../../../Utility/Point';

export default class Pickaxe extends Sprite {
    public create(params: any): void {
        super.create({
            name: 'anchorSprite',
            texture: 'pickaxe',
            anchor: new Point(-0.24, -0.34),
            scale: new Point(1.25, 1.25),
        });
    }
}
